"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import _ from "lodash";
import { AccountSessionMixins } from "@/service/account-session";
import Managerment from "@/views/managements/Managerment.vue";
import MainView from "@/components/layout/MainView.vue";
import UiMenuBar, { MenuController } from "@/components/menu/ManagerMenuBar.vue";
import AccountMessage from "./components/AccountMessage.vue";
import EnterpriseSettings from "./components/EnterpriseSettings.vue";
import EnterpriseVerify from "./components/EnterpriseVerify.vue";
import LiveVerify from "./components/LiveVerify.vue";
import i18n from "@/lang";
let AccountManagement = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.menu_controller = new MenuController(
      false,
      [
        {
          index: "AccountInfo",
          icon_image: "account_sidebar_1",
          name: i18n.t("user_info.user_info_sidebar")
        },
        {
          index: "OrgManage",
          icon_image: "account_sidebar_2",
          name: i18n.t("user_info.org_manage_sidebar"),
          sub_menus: [
            {
              index: "OrgCert",
              name: i18n.t("user_info.org_cert_sidebar")
            },
            // {
            //   index:"LiveVerify",
            //   name: i18n.t("user_info.live_verify_sidebar"),
            // },
            {
              index: "OrgSetting",
              name: i18n.t("user_info.org_settings_sidebar")
            }
          ]
        }
      ],
      "AccountInfo",
      ["OrgManage"]
    );
    this.currentGroup = "";
  }
  changeTeamComponent(data) {
    console.log(data);
    if (data) {
      this.currentGroup = data;
    }
  }
  changeCollapse() {
  }
  created() {
    return __async(this, null, function* () {
      this.currentGroup = "AccountInfo";
    });
  }
  mounted() {
    return __async(this, null, function* () {
      if (this.$route.query.hasOwnProperty("tab")) {
        let _hash = this.$route.query.tab;
        let _index = _.find(this.menu_controller.menu_lists, { index: _hash });
        if (!_index) {
          for (let item of this.menu_controller.menu_lists) {
            if (item.hasOwnProperty("sub_menus")) {
              _index = _.find(item.sub_menus, { index: _hash });
              if (_index !== void 0) {
                break;
              }
            }
          }
        }
        if (_index !== void 0) {
          this.menu_controller.default_components = _index.index;
          this.currentGroup = _index.index;
        }
      }
    });
  }
};
AccountManagement = __decorateClass([
  Component({
    components: {
      Managerment,
      MainView,
      UiMenuBar,
      AccountMessage,
      EnterpriseSettings,
      EnterpriseVerify,
      LiveVerify
    }
  })
], AccountManagement);
export {
  AccountManagement as default
};
